<aside class="budget-card-container">
  <div class="row">
    <div class="col-lg-4 budget-columns">
      <div class="budget-card">
        <div class="row">
          <div class="col-lg-8 card-capital-title">
            <div class="budget-card-title">
              <strong>5-Year</strong> Capital Need <br />(2026-2030)
            </div>
            <div class="budget-card-capital-required">
              {{ fiveYearCapitalNeeds | currency : "USD" : "$" : "1.0-0" }}
            </div>
          </div>
          <div class="col-lg-4 icon-img-location">
            <img
              src="assets/img/icons/capital-5y-lg.svg"
              alt="5-Year Capital Need"
              class="d-none d-md-block img-size"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-4 budget-columns">
      <div class="budget-card">
        <div class="row">
          <div class="col-8 card-capital-title">
            <div class="budget-card-title">
              <strong>20-Year</strong> Capital Need <br />(2026-2045)
            </div>
            <div class="budget-card-capital-required">
              {{ twentyYearCapitalNeeds | currency : "USD" : "$" : "1.0-0" }}
            </div>
          </div>
          <div class="col-4 icon-img-location">
            <img
              src="assets/img/icons/capital-20y-lg.svg"
              alt="20-Year Capital Need"
              class="d-none d-md-block img-size"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-4">
      <div class="budget-card">
        <div class="row">
          <div class="col-8 card-capital-title">
            <div class="budget-card-title">
              <strong>Total</strong> Project Investment<br />(Since 2019)
            </div>
            <div class="budget-card-capital-required">
              {{ _development.totalInvestment | currency : "USD" : "$" : "1.0-0" }}
            </div>
          </div>
          <div class="col-4 icon-img-location">
            <img
              src="assets/img/icons/project-investment-lg.svg"
              alt="Total Project Investment"
              class="d-none d-md-block img-size"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</aside>
